module.exports = __webpack_public_path__ + "media/images/market-narrow-745d8c50d068390d0ad99574ebf9ce76.svg";